import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import {
  Modal as GoModal,
  ModalBody as GoModalBody,
  ModalFooter as GoModalFooter,
  ModalHeader as GoModalHeader,
  StatusIcon,
} from "@gogoro/go-design"
import styled from "styled-components"

const colors = {
  success: "#00b946",
  error: "#ff1923",
  warning: "#fdca35",
  info: "#0069D2",
  question: "#fdca35",
}

const StyledStatusIcon = styled(StatusIcon)`
  display: flex;
  align-items: center;
`

const StyledModalFooter = styled(GoModalFooter)`
  display: flex;
  width: 100%;
`
interface StyledModalHeaderProps {
  showCloseIcon?: boolean
  status?: "success" | "error" | "warning" | "info" | "question"
  backgroundColor?: string
}

const StyledModalHeader = styled(GoModalHeader)<StyledModalHeaderProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
`

interface StatusModalProps {
  isOpen?: boolean
  width?: string
  onToggle?: () => void
  title?: string
  status?: "success" | "error" | "warning" | "info" | "question"
  statusText?: string
  children?: ReactNode
  footer?: ReactNode
}

const StatusModal = ({
  isOpen = false,
  width = "100%",
  onToggle = () => {},
  title = "",
  status = "success",
  statusText,
  children,
  footer,
  ...restProps
}: StatusModalProps) => {
  const { t } = useTranslation("label")
  return (
    <GoModal width={width} isOpen={isOpen} {...restProps}>
      <StyledModalHeader backgroundColor={status ? colors[status] : "#323237"} toggle={onToggle}>
        {title}
      </StyledModalHeader>
      <GoModalBody>
        {status && <StyledStatusIcon status={status}>{statusText || t(`${status}`)}</StyledStatusIcon>}
        {children}
      </GoModalBody>
      {footer && <StyledModalFooter>{footer}</StyledModalFooter>}
    </GoModal>
  )
}

export default StatusModal
